module.exports = __webpack_public_path__ + "static/media/oven-state-3.fa64a095.wav";